define.alias("shared/components/shared/upgrade/trial-monthly-price", "calendar/components/shared/upgrade/trial-monthly-price");